import { useState } from "react";
import { inputClass } from "./AuthLayout";

interface PasswordInputProps {
  id: string;
  name?: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: "current-password" | "new-password";
  required?: boolean;
  minLength?: number;
  disabled?: boolean;
  placeholder?: string;
}

export function PasswordInput({
  id,
  name,
  value,
  onChange,
  autoComplete = "current-password",
  required,
  minLength,
  disabled,
  placeholder,
}: PasswordInputProps) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        name={name ?? id}
        type={shown ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        disabled={disabled}
        placeholder={placeholder}
        className={`${inputClass} pr-12`}
        data-testid={`password-input-${id}`}
      />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? "Passwort verbergen" : "Passwort anzeigen"}
        aria-pressed={shown}
        className="absolute inset-y-0 right-0 px-3 inline-flex items-center justify-center min-w-[44px] text-fg-muted hover:text-fg focus:outline-none focus-visible:ring-2 focus-visible:ring-outline-strong rounded-r-xl"
        data-testid={`toggle-pw-${id}`}
      >
        <span aria-hidden>{shown ? "🙈" : "👁"}</span>
      </button>
    </div>
  );
}
